import Service from "../../AuthService";
const checked = {
    getCheckList(page) {
        return Service.get("/checklist?page="+page);
    },
    getCheckListByID(id) {
        return Service.get("/checklist/"+id);
    },
    createCheckList(data){
        return Service.post("/checklist",data);
    },
    updateCheckList(id,data) {
        return Service.put("/checklist/"+id ,data);
    },
    searchCheckList(page,material_id,date) {
        return Service.post('/checklist-search?page='
            + page +
            '&material_id='+
            material_id+
            '&date='
            +date);
    }
};
export default checked;
